import type { Range } from '@/components/listings/search/SearchFilters/shared/commonTypes'
import { createNumericRangeAppliedComponent } from '@/components/listings/search/SearchFilters/shared/filterUtils'
import type {
  ListingFilter,
  FilterProps,
} from '@/components/listings/search/SearchFilters/types'

import IntegerRangeFilter from '../../shared/NumericRangeFilter/IntegerRangeFilter'

const NumberOfUnitsFilter: ListingFilter<Range> = ({
  onChange,
  desktopScreen,
  value,
  onError,
}: FilterProps<Range>) => {
  return (
    <IntegerRangeFilter
      selected={value}
      onChange={onChange}
      onError={onError}
      desktopScreen={desktopScreen}
      analyticsTitle="Number_of_Units"
    />
  )
}

NumberOfUnitsFilter.expandedOnInit = false
NumberOfUnitsFilter.getOwnProps = ({ state, updateFilters }) => ({
  filterKey: 'units',
  onChange: (units: Range) => {
    updateFilters({ units })
  },
  value: state.filters.units,
})

NumberOfUnitsFilter.label = 'Filters.units'

NumberOfUnitsFilter.Applied = createNumericRangeAppliedComponent(
  'units',
  NumberOfUnitsFilter.label
)

export default NumberOfUnitsFilter
